import { PageContainer, ProFormText } from "@ant-design/pro-components";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { TABLEPAI, PageEnum, USER_MANAG } from "@/enums/pageEnum";
import { PageTitle, CustomModal, ComfirmButton } from "@/components";
import { eidtGroup, deleleGroup, getGroupPermiss, organPermiss } from "@api";
import Permissions from "@/pages/organization/type-detail/permissions";
import AddPubCom from "./addPubCom";

export default function TypeDetailPage() {
  const { state, pathname } = useLocation();
  const { t } = useTranslation();
  const { id } = useParams();
  const navigation = useNavigate();
  const MEMBERS = "Members";
  const [tabActiveKey, setTabActiveKey] = useState<string>(MEMBERS);
  const [defaMenus, setDefaMenus] = useState<string[] | undefined>();
  const [userMenus, setUserMenus] = useState<string[] | undefined>();

  return (
    <div className="bg-[#f2f2f2] dark:bg-[#000] typeDetailCalss">
      <PageTitle title={state?.name} />
      <PageContainer
        tabList={[
          { tab: t("members"), key: MEMBERS },
          { tab: t("permissions"), key: "permissions" },
        ]}
        tabActiveKey={tabActiveKey}
        onTabChange={async (key) => {
          setTabActiveKey(key);
          if (key !== MEMBERS) {
            const userPers = await getGroupPermiss(id);
            const allPerms = await organPermiss();
            const cuPers = allPerms.data.body?.filter(
              (item: string) => item !== USER_MANAG
            );
            setUserMenus(userPers.data.body?.sort() || []);
            setDefaMenus(cuPers.sort() || []);
          } else {
            setUserMenus([]);
            setDefaMenus([]);
          }
        }}
        header={{
          title: <span className="text-[20px] font-medium">{state?.name}</span>,
          breadcrumb: {
            items: [
              { title: <Link to={PageEnum.USRTGROUP}>{t("groups")}</Link> },
              { title: t("detail") },
            ],
          },
          extra: [
            <span key="1">
              <CustomModal
                title={t("rename")}
                onClick={(values) => {
                  navigation(pathname, {
                    replace: true,
                    state: { ...state, name: values.name },
                  });
                }}
                initValues={{ name: state?.name }}
                otherParams={{ id }}
                request={eidtGroup}
              >
                <ProFormText
                  name="name"
                  label={t("groupName")}
                  rules={[{ required: true }]}
                />
              </CustomModal>
            </span>,
            <span key={2}>
              <ComfirmButton
                onClick={() => {
                  deleleGroup([id || ""]).then(() => {
                    navigation(-1);
                  });
                }}
                title={t("delete")}
              />
            </span>,
          ],
        }}
      >
        {tabActiveKey === MEMBERS ? (
          <AddPubCom groupId={id || ""} />
        ) : (
          <Permissions
            userPermission={userMenus}
            allPermissions={defaMenus}
            groupId={id}
            apiUrl={TABLEPAI.GROUP_PERMISS}
          />
        )}
      </PageContainer>
    </div>
  );
}
